<template>
  <DialogDrawer
    ref="dialog"
    data-testid="cookie-dialog"
    class="dialog-cookie"
    placement="bottom"
    :dismissible="false"
  >
    <p class="mb-0 me-3">
      {{
        translate(
          'We use cookies to enhance your experience. For a complete overview of all cookies used and more info, please see our ',
        )
      }}
      <router-link
        to="/cookiepolicy"
        router-link-exact-active
        data-testid="cookie.banner.policy.link"
      >
        <u>{{ translate('Cookie Policy') }}</u> </router-link
      >.
    </p>
    <template #buttons>
      <BootstrapButton
        name="accept-cookies"
        variant="secondary"
        size="sm"
        :aria-label="translate('Accept cookies')"
        autofocus
        @click="acceptCookies"
      >
        {{ translate('Accept') }}
      </BootstrapButton>
      <BootstrapButton
        name="decline-cookies"
        variant="ghost"
        size="sm"
        :aria-label="translate('Decline cookies')"
        @click="declineCookies"
      >
        {{ translate('Decline') }}
      </BootstrapButton>
    </template>
  </DialogDrawer>
</template>
<script lang="ts" setup>
import DialogDrawer from '@/components/shared/custom/DialogDrawer/DialogDrawer.vue';

const {translate} = useLocalisation();

const hotJarStore = useHotJarStore();
const clarityStore = useClarityStore();

const route = useRoute();
const router = useRouter();
const {setItem, getItem} = useLocalStorage();

const dialog = useTemplateRef<InstanceType<typeof DialogDrawer>>('dialog');

const cookieConsent = ref<null | boolean>(null);

const acceptCookies = () => {
  setItem('cookieConsent', true);
  hotJarStore.startHotJar();
  clarityStore.startClarity();
  dialog.value?.close();
  if (route.name === 'cookiepolicy') router.push({name: 'home'});
};
const declineCookies = () => {
  setItem('cookieConsent', false);
  cookieConsent.value = getItem('cookieConsent');
  dialog.value?.close();
};

onMounted(() => {
  cookieConsent.value = getItem('cookieConsent');
  if (!cookieConsent.value) dialog.value?.openModal();
});
</script>
<style lang="scss" scoped>
.dialog-cookie {
  z-index: 11; // The sidebar is 10
}

.dialog-cookie :deep(div:has(button)) {
  margin-top: 1rem;
}

@media (width >= 992px) {
  .dialog-cookie :deep(form) {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    align-items: center;
  }

  .dialog-cookie :deep(div:has(button)) {
    margin-top: 0 !important;
  }
}
</style>
